import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "payment_confirm" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", null, "3Dセキュア認証が必要です。", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, "下記リンクをクリックしてstripeのサイトに進み、認証を完了して下さい。", -1);
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "footerFixed" };
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'payment_confirm',
    props: {
        common: null,
        url: null,
        init_loading: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _hoisted_3,
                    _createElementVNode("a", {
                        rel: "stylesheet",
                        href: props.url
                    }, "ここをクリックしてください。", 8, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
